<template>
  <span>
    <booking-status-canceled v-if="booking && booking.canceled" style="margin: 1px;"></booking-status-canceled>
    <computed-status-badge v-else :status-list="allBookingStatus" :value="computedStatus" style="margin: 1px;" />
  </span>
</template>

<script>

import {LocaleUtils} from '@/utils/locale-utils';
import ComputedStatusBadge from '@/components/ComputedStatusBadge';
import BookingStatusCanceled from './BookingStatusCanceled';

export default {
  name: 'BookingStatus',
  components: {BookingStatusCanceled, ComputedStatusBadge},
  mixins: [
    LocaleUtils
  ],
  props: ['value', 'booking'],
  computed: {
    computedStatus () {
      if (this.booking) {
        return this.booking.status;
      } else {
        return this.value;
      }
    },
    allBookingStatus () {
      return [
        {
          value: 0,
          text: this.trans('booking.statusOpen'),
          color: 'pending'
        },
        {
          value: 1,
          text: this.trans('booking.statusClosed'),
          color: 'success'
        }
      ]
    },
  },
}
</script>
